<template lang="pug">
  self-layout
    template(#header)
      self-header
    template(#call-to-action1)
      self-call-to-action1
    template(#avatar)
      self-avatar
    template(#name)
      self-name
    template(#counter1)
      self-counter1
    template(#type)
      self-type
    template(#counter2)
      self-counter2
    template(#call-to-action2)
      self-call-to-action2
    template(#description)
      self-description
    template(#call-to-action3)
      self-call-to-action3
</template>

<script>
import SelfLayout from './layout/'
import SelfAvatar from './avatar/'
import SelfName from './name/'
import SelfType from './type/'
import SelfCounter1 from './counter-followers/'
import SelfCounter2 from './counter-supports/'
import SelfCallToAction1 from './action-toggle-subscribe/'
import SelfCallToAction2 from './action-support/'
import SelfCallToAction3 from './action-donate/'
import SelfDescription from './description/'
import SelfHeader from './header/'

export default {
  components: {
    SelfLayout,
    SelfAvatar,
    SelfName,
    SelfType,
    SelfCounter1,
    SelfCounter2,
    SelfCallToAction1,
    SelfCallToAction2,
    SelfCallToAction3,
    SelfDescription,
    SelfHeader
  }
}
</script>
